import { render, staticRenderFns } from "./SeccionMenu.vue?vue&type=template&id=242fabd6&scoped=true"
import script from "./SeccionMenu.vue?vue&type=script&lang=js"
export * from "./SeccionMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242fabd6",
  null
  
)

export default component.exports